module.exports = __webpack_public_path__ + "static/images/map/markers/in_route_marker.png";